import { render, staticRenderFns } from "./ResourceHistoryModal.vue?vue&type=template&id=75a1e8aa"
import script from "./ResourceHistoryModal.vue?vue&type=script&lang=js"
export * from "./ResourceHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports